import axiosInstance from './axiosInstance';

export const chatApi = {
  getChatAdmins: () => axiosInstance.get('/chat/admins'),
  getChatHistory: (adminId, params) => axiosInstance.get(`/chat/history/${adminId}`, { params }),
  sendMessage: (data) => axiosInstance.post('/chat/send', data)
};
